import { underscored, camelize } from 'underscore.string'
import fecha from 'fecha'

const SimpleUI = {
  version: '1.0.0',
  install: function (Vue, options) {
    Vue.prototype.$defaultEnterTransition = function () {
      window.scroll({ top: 0, behavior: 'smooth' })
    }
    Vue.mixin({
      methods: {
        formGroupClass (field, others = []) {
          let classes = {
            'form-group': true,
            'has-error': this.errors.has(field)
          }
          others.forEach((i) => {
            classes[i] = true
          })
          return classes
        },
        setUserLocale (user) {
          if (user && user.language) {
            this.$store.dispatch('setLocale', user.language.locale)
          }
        },
        redirectAfterLogin () {
          let name = this.$route.query.redirect ? this.$route.query.redirect : 'home'
          let params = this.$route.query.params || null
          let query = this.$route.query.query || null
          if (params) {
            try {
              params = JSON.parse(params)
            } catch (e) {
              params = null
            }
          }
          if (query) {
            try {
              query = JSON.parse(query)
            } catch (e) {
              query = null
            }
          }
          this.$router.push({ name: name, params: params, query: query })
        },
        dataToModel (data) {
          return Object.keys(this.model).map((key) => {
            let keyUnderscored = this.underscored(key)
            if (data[keyUnderscored]) {
              this.model[key] = data[keyUnderscored]
            }
          })
        },
        scrollTop (top = 0) {
          window.scroll({ top: top, behavior: 'smooth' })
        },
        underscored (value) {
          return underscored(value)
        },
        camelize (value) {
          return camelize(value)
        }
      }
    })
    Vue.filter('date', (value, format = 'DD/MM/YYYY') => {
      try {
        let date = fecha.parse(value, 'YYYY-MM-DD')
        return fecha.format(date, format)
      } catch (e) {
        return ''
      }
    })
    Vue.filter('dateTime', (value, format = 'DD/MM/YYYY HH:mm:ss') => {
      let date = fecha.parse(value, 'YYYY-MM-DD HH:mm:ss')
      return fecha.format(date, format)
    })
  }
}

export default SimpleUI



// WEBPACK FOOTER //
// ./src/plugins/SimpleUI.js